import MapaProvincia from "../reportes/MapaProvincia"
import React, { useEffect, useMemo, useRef, useState } from "react";
import HeaderCustomized from "../imgBackground/HeaderCustomized";

// Función para obtener y procesar los datos desde la URL
// Función simplificada que elimina duplicados y promedia
// Función useSampleDataSimple con ordenamiento
// Función useSampleDataSimple con Usuarios_Totales y Usuarios_Activos
// Función useSampleDataSimple con Usuarios_Totales (promedio) y Usuarios_Activos (máximo)
const useSampleDataSimple = (nomProv) => {
  const [sampleData, setSampleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const response = await fetch('https://img-dinoblanco-shs.s3.us-east-1.amazonaws.com/c/r/res_colegios_aldiadelmes.json');
        const rawData = await response.json();

        // Filtrar por provincia
        const datosFiltrados = rawData.filter(item => item.provincia === nomProv);
        
        // Usar Map para eliminar duplicados y promediar
        const colegiosMap = new Map();

        datosFiltrados.forEach(item => {
          const key = `${item.colegio}-${item.nivel}`;
          const icp = typeof item.ICP === 'string' ? parseFloat(item.ICP)*100 : item.ICP*100;
          const ihl = typeof item.INorm_Promedio === 'string' ? parseFloat(item.INorm_Promedio)*100 : item.INorm_Promedio*100;
          const igl = typeof item.IGL === 'string' ? parseFloat(item.IGL)*100 : item.IGL*100;
          const usuariosTotales = typeof item.Usuarios_Totales === 'string' ? parseInt(item.Usuarios_Totales) : item.Usuarios_Totales;
          const usuariosActivos = typeof item.Usuarios_Activos === 'string' ? parseInt(item.Usuarios_Activos) : item.Usuarios_Activos;

          if (!colegiosMap.has(key)) {
            colegiosMap.set(key, {
              provincia: item.provincia,
              distrito: item.distrito,
              nivel: item.nivel,
              colegio: item.colegio,
              sumICP: 0,
              sumIHL: 0,
              sumIGL: 0,
              sumUsuariosTotales: 0,
              maxUsuariosActivos: 0, // Cambiado a máximo
              count: 0
            });
          }

          const colegio = colegiosMap.get(key);
          if (!isNaN(icp)) {
            colegio.sumICP += icp;
            colegio.sumIHL += ihl;
            colegio.count++;
          }
          if (!isNaN(igl)) colegio.sumIGL += igl;
          if (!isNaN(usuariosTotales)) colegio.sumUsuariosTotales += usuariosTotales;
          // Para Usuarios_Activos, tomamos el valor máximo
          if (!isNaN(usuariosActivos) && usuariosActivos > colegio.maxUsuariosActivos) {
            colegio.maxUsuariosActivos = usuariosActivos;
          }
        });

        // Convertir a array y calcular promedios
        const datosProcesados = Array.from(colegiosMap.values()).map(colegio => ({
          provincia: colegio.provincia,
          distrito: colegio.distrito,
          nivel: colegio.nivel,
          colegio: colegio.colegio,
          ICP: colegio.count > 0 ? Math.round((colegio.sumICP / colegio.count) * 100) / 100 : 0,
          IHL: colegio.count > 0 ? Math.round((colegio.sumIHL / colegio.count) * 100) / 100 : 0,
          IGL: colegio.count > 0 ? Math.round((colegio.sumIGL / colegio.count) * 100) / 100 : 0,
          Usuarios_Totales: Math.ceil(colegio.sumUsuariosTotales / (colegio.count || 1)), // Promedio redondeado arriba
          Usuarios_Activos: colegio.maxUsuariosActivos // Valor máximo
        }));

        // ORDENAR por los criterios especificados
        const datosOrdenados = datosProcesados.sort((a, b) => {
          // 1. Ordenar por NIVEL (inicial, primaria, secundaria)
          const niveles = { 'inicial': 1, 'primaria': 2, 'secundaria': 3 };
          const nivelA = niveles[a.nivel] || 4;
          const nivelB = niveles[b.nivel] || 4;
          if (nivelA !== nivelB) return nivelA - nivelB;

          // 2. Ordenar por PROVINCIA
          if (a.provincia !== b.provincia) {
            return a.provincia.localeCompare(b.provincia);
          }

          // 3. Ordenar por DISTRITO
          if (a.distrito !== b.distrito) {
            return a.distrito.localeCompare(b.distrito);
          }


          // 4. Ordenar por Usuarios_Totales
          if (a.Usuarios_Totales !== b.Usuarios_Totales) {
            return b.Usuarios_Totales - a.Usuarios_Totales;
            
          }

          // 5. Ordenar por COLEGIOS (descendente)
          return a.colegio.localeCompare(b.colegio);
        });

        setSampleData(datosOrdenados);

      } catch (err) {
        setError(`Error cargando datos: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [nomProv]);

  return { sampleData, loading, error };
};


function EstadisticasLectoresMapDiarioMes({ user}) {

  const nomProv = user.attributes['zoneinfo']

  const [selected, setSelected] = useState(null);
  const [nivelFilter, setNivelFilter] = useState('todos');
  const [mesFilter, setMesFilter] = useState('todos');
  
  // Usar el hook para obtener sampleData
  const { sampleData, loading: dataLoading, error: dataError } = useSampleDataSimple(nomProv);

  


    return (
      <>

    <HeaderCustomized nivel_estudiante={user.attributes['custom:Nivel']} grade_estudiante={user.attributes['custom:grade']} especialidad_usuario={user.attributes['custom:especialidad']}  categoria_usuario={user.attributes['custom:categoria_usuario']}  grado_estudiante={user.attributes['custom:Grado']} colegio_usuario={user.attributes['custom:Colegio']} username={user.attributes['given_name']} zoneinfo={user.attributes['zoneinfo']} ></HeaderCustomized>


       <MapaProvincia 
      nomProv={nomProv}
      sampleData={sampleData}
      height="600px"
    />
      
      </>
       
    )

}

export default EstadisticasLectoresMapDiarioMes